import React, { useContext, useEffect } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";
import axios from "axios";
import { base_url } from "../../config";
import "./style.scss";
import WhiteBoxLayout from "../../components/WhiteBoxLayout/WhiteBoxLayout";
import OrderSummary from "../../components/OrderSummary/OrderSummary";
import NextBar from "../../components/NextBar/NextBar";

function Conditions() {
  const { setError, reload, setReload, data, clickedNext, setClickedNext } =
    useContext(RegistrationContext);

  const handleSelect = async () => {
    // Reset login error state

    setError("");
    try {
      // Make a POST request to your authentication endpoint
      const response = await axios.post(`${base_url}/api/progress`, {});
      setReload(reload + 1);
    } catch (error) {
      setError("Unexpected error. " + error.response.data.message);
    }
  };

  useEffect(() => {
    if (clickedNext === 0) return;
    setClickedNext(0);
    handleSelect();
  }, [clickedNext]);

  return (
    <>
      <WhiteBoxLayout title="Conditions">
        <OrderSummary />
      </WhiteBoxLayout>
      <NextBar handleSelect={handleSelect} />
    </>
  );
}

export default Conditions;
